import type {
  CommunityFeedSurveyDto,
  MessageStatusChangeRequestV2,
  MessageV2Dto,
  SurveyDetailsV2Dto,
} from "@/api/types";
import type { TranslationFunction } from "@/translations";

export const DEFAULT_COMMUNITY_FEED_TAB_ADMIN = "announcements" as const;
export const DEFAULT_COMMUNITY_FEED_TAB_RESIDENT = "myFeed" as const;
export const MAX_AMOUNT_IMAGES_PER_POST = 20;

export type MessageRouteParams = {
  list: {
    tab?: "all" | "announcements" | "myFeed" | "own" | "question" | "scheduled" | "deleted";
    search?: string;
    startDate?: string;
    endDate?: string;
    groupIds?: string;
  };
};

export type MessageRouteStates = {
  list?: {
    newMessageId?: string;
    residentCreatePostType?: MessageV2Dto["messageLabel"] | null;
    groupId?: string;
    isGeneral?: boolean;
    contentNotFoundReason?: "deleted" | "not-found";
  };
  adminCreatePost?: {
    groupId?: string;
  };
};

export type AdminPostAudienceType = "project" | "projectConnection" | "group";

export type AudienceFormValues = {
  audienceType: AdminPostAudienceType | undefined;
  audienceEntityId: string | undefined;
};

export const getClosePostReasonLabel = ({
  reasonType,
  t,
}: {
  reasonType: MessageStatusChangeRequestV2["reason"];
  t: TranslationFunction;
}): string => {
  switch (reasonType) {
    case "solvedNotDetailed":
      return t("component.community-post.actions.close.solved-not-detailed");
    case "mistake":
      return t("component.community-post.actions.close.mistake");
    case "noResponse":
      return t("component.community-post.actions.close.no-response");
    case "irrelevant":
      return t("component.community-post.actions.close.irrelevant");
    default:
      return "";
  }
};

export const getCommunitySurveyCtaLabel = (
  t: TranslationFunction,
  survey: CommunityFeedSurveyDto | SurveyDetailsV2Dto,
): string => {
  let ctaLabel =
    survey.scope === "automated"
      ? t("component.community-survey.button.start-automated-survey")
      : t("component.community-survey.button.start-standard-survey");
  if (survey.canRespond === "notAllowed") {
    ctaLabel = t("component.community-survey.button.not-allowed");
  } else if (survey.canRespond === "alreadyAnswered") {
    ctaLabel = t("component.community-survey.button.already-answered");
  } else if (survey.canRespond === "notStarted") {
    ctaLabel = t("component.community-survey.button.not-started");
  } else if (survey.canRespond === "ended") {
    ctaLabel = t("component.community-survey.button.ended");
  }

  return ctaLabel;
};
